module.exports = __webpack_public_path__ + "static/media/生成对抗网络体验.4361c458.png";